import React, { Component } from "react";
import { can } from "../../utils/permission";
import {
  company,
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  DatePicker,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  ActionIconButton,
  ACTION_ICONS,
  fmtInt,
} from "../../components/CustomComponent.js";

// 1 โครงการ (project_code) มีได้หลาย WBS -> แยกเป็น 2 แท็บ: โครงการ / WBS (ตาราง wbs อ้างกลับมาที่โครงการ)
const TAB_PROJECT = "project";
const TAB_WBS = "wbs";
const PAGE_SIZE = 10;

// ฟิลด์โครงการที่มาจาก SAP (ไฟล์ 16_project_Template.xlsx) - แก้มือได้จากหน้านี้เช่นกัน
const SAP_TEXT_FIELDS = ["owner_code", "owner_name", "processing_status", "project_manager", "description"];
const SAP_DATE_FIELDS = ["planned_start_date", "planned_finish_date", "actual_start_date", "actual_finish_date"];
const EMPTY_SAP_FIELDS = [...SAP_TEXT_FIELDS, ...SAP_DATE_FIELDS].reduce((acc, key) => ({ ...acc, [key]: "" }), {});

// yyyy-mm-dd -> dd/mm/yyyy สำหรับแสดงในตาราง
const formatDate = (value) => {
  const m = String(value ?? "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : "";
};

export default class AdminProjects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_tab: TAB_PROJECT,

      // ---- Tab: Projects ----
      filter_search: "",
      page: 1,
      count: 0,
      data: [],

      modal_create: false,
      modal_update: false,

      // Form state (modal)
      uid: "",
      company_id: company?.id,
      project_code: "",
      name: "",
      ...EMPTY_SAP_FIELDS,
      // ข้อมูลจาก SAP ที่แสดงอย่างเดียว (มากับไฟล์นำเข้า)
      sap_created_by: "",
      sap_created_on: "",
      is_active: "Active",

      // ---- Tab: WBS ----
      wbs_filter_search: "",
      wbs_filter_project_id: "",
      wbs_page: 1,
      wbs_count: 0,
      data_wbs: [],
      data_project: [], // ตัวเลือกโครงการ (filter + modal ของ WBS)

      modal_wbs_create: false,
      modal_wbs_update: false,

      wbs_uid: "",
      wbs_project_id: "",
      wbs_element: "",
      wbs_element_name: "",
      entity_guid: "",
      wbs_is_active: "Active",
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  // ============================== Projects ==============================
  Get = async (page) => {
    const { filter_search } = this.state;
    loading(true);

    let result = await GET("admin/projects", {
      page_size: PAGE_SIZE,
      page,
      data_search: filter_search,
    });

    if (result?.status) {
      this.setState({ data: result.data || [], count: result.pagination?.count || 0, page });
    }
    loading(false);
  };

  resetForm = () => {
    this.setState({
      uid: "",
      project_code: "",
      name: "",
      ...EMPTY_SAP_FIELDS,
      sap_created_by: "",
      sap_created_on: "",
      is_active: "Active",
    });
  };

  openCreateModal = () => {
    this.resetForm();
    this.setState({ modal_create: true, modal_update: false });
  };

  openEditModal = (item) => {
    this.setState({
      modal_create: false,
      modal_update: true,
      uid: item.uid,
      project_code: item.project_code || "",
      name: item.name || "",
      ...[...SAP_TEXT_FIELDS, ...SAP_DATE_FIELDS].reduce((acc, key) => ({ ...acc, [key]: item[key] || "" }), {}),
      sap_created_by: item.sap_created_by || "",
      sap_created_on: item.sap_created_on || "",
      is_active: item.is_active ? "Active" : "Inactive",
    });
  };

  CreateUpdate = async () => {
    const { uid, company_id, project_code, name, is_active } = this.state;

    if (!project_code.trim()) {
      alert("", "warning", t("warning"), t("verify_project_code"));
      return;
    } else if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_project_name"));
      return;
    }

    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) {
      return;
    }

    loading(true);
    const body = {
      company_id,
      project_code: project_code.trim(),
      name: name.trim(),
      ...SAP_TEXT_FIELDS.reduce((acc, key) => ({ ...acc, [key]: String(this.state[key] || "").trim() }), {}),
      ...SAP_DATE_FIELDS.reduce((acc, key) => ({ ...acc, [key]: this.state[key] || "" }), {}),
      is_active: is_active === "Active",
    };

    const result = !uid ? await POST("admin/projects", body) : await PUT("admin/projects/" + uid, body);

    if (result?.status === true) {
      alert("#", "success");
      this.setState({ modal_create: false, modal_update: false, data_project: [] });
      this.Get(this.state.page);
    } else {
      alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    loading(false);
  };

  Delete = async (uid) => {
    // ลบโครงการ = ลบ WBS ใต้โครงการนั้นด้วย จึงเตือนให้ชัด
    if (!(await alert("", "warning", t("delete_item"), t("delete_project_with_wbs_desc"), t("confirm"), t("cancel")))) {
      return;
    }
    loading(true);
    const result = await DELETE("admin/projects/" + uid, null);
    if (result?.status) {
      alert("#", "success");
      this.setState({ data_project: [] });
      this.Get(this.state.page);
    } else {
      alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    loading(false);
  };

  // ============================== WBS ==============================
  switchTab = (tab) => {
    if (tab === this.state.active_tab) return;
    this.setState({ active_tab: tab }, () => {
      if (tab === TAB_WBS) {
        this.GetProjectOptions();
        this.GetWbs(1);
      } else {
        this.Get(this.state.page);
      }
    });
  };

  // กดจำนวน WBS ในตารางโครงการ -> ไปแท็บ WBS โดยกรองเฉพาะโครงการนั้น
  openWbsOfProject = (project) => {
    this.setState({ active_tab: TAB_WBS, wbs_filter_project_id: project.uid, wbs_filter_search: "" }, () => {
      this.GetProjectOptions();
      this.GetWbs(1);
    });
  };

  // โหลดครั้งเดียว (ล้างทิ้งเมื่อมีการเพิ่ม/แก้/ลบโครงการ)
  GetProjectOptions = async () => {
    if (this.state.data_project.length) return;
    const result = await GET("admin/projects", { page_size: 10000, page: 0, data_search: "" });
    if (!result?.status) return;
    this.setState({
      data_project: (result.data || []).map((e) => ({
        value: e.uid,
        label: [e.project_code, e.name].filter(Boolean).join(" "),
      })),
    });
  };

  GetWbs = async (page) => {
    const { wbs_filter_search, wbs_filter_project_id } = this.state;
    loading(true);

    let result = await GET("admin/wbs", {
      page_size: PAGE_SIZE,
      page,
      data_search: wbs_filter_search,
      project_id: wbs_filter_project_id || "",
    });

    if (result?.status) {
      this.setState({ data_wbs: result.data || [], wbs_count: result.pagination?.count || 0, wbs_page: page });
    }
    loading(false);
  };

  openWbsCreateModal = () => {
    this.setState({
      modal_wbs_create: true,
      modal_wbs_update: false,
      wbs_uid: "",
      // กรองโครงการอยู่ = ตั้งใจเพิ่ม WBS ให้โครงการนั้น
      wbs_project_id: this.state.wbs_filter_project_id || "",
      wbs_element: "",
      wbs_element_name: "",
      entity_guid: "",
      wbs_is_active: "Active",
    });
  };

  openWbsEditModal = (item) => {
    this.setState({
      modal_wbs_create: false,
      modal_wbs_update: true,
      wbs_uid: item.uid,
      wbs_project_id: item.project?.uid || "",
      wbs_element: item.wbs_element || "",
      wbs_element_name: item.wbs_element_name || "",
      entity_guid: item.entity_guid || "",
      wbs_is_active: item.is_active ? "Active" : "Inactive",
    });
  };

  CreateUpdateWbs = async () => {
    const { wbs_uid, company_id, wbs_project_id, wbs_element, wbs_element_name, entity_guid, wbs_is_active } = this.state;

    if (!wbs_project_id) {
      alert("", "warning", t("warning"), t("verify_wbs_project"));
      return;
    } else if (!wbs_element.trim()) {
      alert("", "warning", t("warning"), t("verify_wbs_element"));
      return;
    }

    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) {
      return;
    }

    loading(true);
    const body = {
      company_id,
      project_id: wbs_project_id,
      wbs_element: wbs_element.trim(),
      wbs_element_name: wbs_element_name.trim(),
      entity_guid: entity_guid.trim(),
      is_active: wbs_is_active === "Active",
    };

    const result = !wbs_uid ? await POST("admin/wbs", body) : await PUT("admin/wbs/" + wbs_uid, body);

    if (result?.status === true) {
      alert("#", "success");
      this.setState({ modal_wbs_create: false, modal_wbs_update: false });
      this.GetWbs(this.state.wbs_page);
    } else {
      alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    loading(false);
  };

  DeleteWbs = async (uid) => {
    if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) {
      return;
    }
    loading(true);
    const result = await DELETE("admin/wbs/" + uid, null);
    if (result?.status) {
      alert("#", "success");
      this.GetWbs(this.state.wbs_page);
    } else {
      alert("", "warning", t("warning"), result?.message || t("error_occurred"));
    }
    loading(false);
  };

  // ============================== Render ==============================
  renderStatusBadge = (isActive) =>
    isActive ? (
      <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
    ) : (
      <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
    );

  renderStatusRadio = (name, value, onChange) => (
    <div className="col-12 mt-4 border-top pt-4">
      <h6 className="fw-bold mb-1 d-flex align-items-center">
        <span className="icon text-primary me-2">{""}</span> {t("status")}
      </h6>
      <small className="text-muted d-block mb-3">{t("status_desc")}</small>
      <div className="d-flex gap-4">
        {["Active", "Inactive"].map((status) => (
          <div key={status} className="form-check d-flex align-items-center gap-2">
            <input
              className="form-check-input mt-0 pointer"
              type="radio"
              name={name}
              id={`${name}${status}`}
              checked={value === status}
              onChange={() => onChange(status)}
            />
            <label className="form-check-label text-dark text-14 pointer" htmlFor={`${name}${status}`}>
              {t(status === "Active" ? "active" : "inactive")}
            </label>
          </div>
        ))}
      </div>
    </div>
  );

  renderProjectTab() {
    const { data, count, page, filter_search } = this.state;

    return (
      <>
        {/* Filter Toolbar */}
        <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
            <div className="d-flex flex-wrap gap-2 flex-grow-1">
              <div className="position-relative">
                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">
                  {""}
                </span>
                <input
                  type="text"
                  className="form-control ps-5 wpx-350"
                  style={{ height: "38px" }}
                  placeholder={t("search_projects")}
                  value={filter_search}
                  onChange={(e) => this.setState({ filter_search: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                />
              </div>
              <div className="d-flex gap-2">
                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                  {t("filter")}
                </button>
                <button
                  className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                  onClick={() => this.setState({ filter_search: "" }, () => this.Get(1))}
                >
                  {t("reset")}
                </button>
              </div>
            </div>
            {can("projects.create") && (
              <button
                className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                onClick={this.openCreateModal}
              >
                <span className="me-2 text-16">+</span> {t("add_project")}
              </button>
            )}
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0" style={{ minWidth: "1100px" }}>
              <thead>
                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                  <th className="py-3 border-0">{t("project_code")}</th>
                  <th className="py-3 border-0">{t("project_name")}</th>
                  <th className="py-3 border-0">{t("project_planned_period")}</th>
                  <th className="py-3 border-0">{t("processing_status")}</th>
                  <th className="py-3 border-0 text-center">{t("wbs_count")}</th>
                  <th className="py-3 border-0 text-center">{t("status")}</th>
                  <th className="py-3 border-0 text-center">{t("actions")}</th>
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center text-secondary py-5">
                      {t("no_data")}
                    </td>
                  </tr>
                ) : (
                  data.map((item, idx) => (
                    <tr key={idx} className="border-bottom border-light bg-white">
                      <td>
                        <div className="text-secondary text-14">{item.project_code}</div>
                      </td>
                      <td>
                        <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "300px" }} title={item.name}>
                          {item.name}
                        </div>
                      </td>
                      <td>
                        <div className="text-secondary text-14 text-nowrap">
                          {[formatDate(item.planned_start_date), formatDate(item.planned_finish_date)].filter(Boolean).join(" - ") || "-"}
                        </div>
                      </td>
                      <td>
                        <div className="text-secondary text-14">{item.processing_status || "-"}</div>
                      </td>
                      <td className="text-center">
                        <span
                          className="text-primary text-14 fw-bold pointer"
                          title={(item.wbs || []).map((wbs) => wbs.wbs_element).join("\n")}
                          onClick={() => this.openWbsOfProject(item)}
                        >
                          {item.wbs_count ?? 0}
                        </span>
                      </td>
                      <td className="text-center">{this.renderStatusBadge(item.is_active)}</td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-2 justify-content-center">
                          <ActionIconButton label={can("projects.update") ? t("edit") : t("view")} icon={can("projects.update") ? ACTION_ICONS.edit : ACTION_ICONS.view} variant={can("projects.update") ? "warning" : "primary"} onClick={() => this.openEditModal(item)} />
                          {can("projects.delete") && (
                            <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.Delete(item.uid)} />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer Pagination */}
        <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
          <div>
            {t("showing")} 1-{data.length} {t("of")} {fmtInt(count)} {t("items")}
          </div>
          <Pagination
            className="mb-0"
            count={Math.ceil(count / PAGE_SIZE) || 1}
            page={page}
            showFirstButton={false}
            showLastButton={false}
            onChange={(_, p) => this.Get(p)}
          />
        </div>
      </>
    );
  }

  renderWbsTab() {
    const { data_wbs, wbs_count, wbs_page, wbs_filter_search, wbs_filter_project_id, data_project } = this.state;

    return (
      <>
        {/* Filter Toolbar */}
        <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
            <div className="d-flex flex-wrap gap-2 flex-grow-1">
              <div className="position-relative">
                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">
                  {""}
                </span>
                <input
                  type="text"
                  className="form-control ps-5 wpx-350"
                  style={{ height: "38px" }}
                  placeholder={t("search_wbs")}
                  value={wbs_filter_search}
                  onChange={(e) => this.setState({ wbs_filter_search: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.GetWbs(1)}
                />
              </div>
              <div className="wpx-300">
                <Select
                  className="form-control"
                  options={data_project}
                  value={wbs_filter_project_id}
                  placeholder={t("all_projects")}
                  defaultLabel={t("all_projects")}
                  onChange={(value) => this.setState({ wbs_filter_project_id: value || "" }, () => this.GetWbs(1))}
                />
              </div>
              <div className="d-flex gap-2">
                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.GetWbs(1)}>
                  {t("filter")}
                </button>
                <button
                  className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                  onClick={() => this.setState({ wbs_filter_search: "", wbs_filter_project_id: "" }, () => this.GetWbs(1))}
                >
                  {t("reset")}
                </button>
              </div>
            </div>
            {can("projects.create") && (
              <button
                className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                onClick={this.openWbsCreateModal}
              >
                <span className="me-2 text-16">+</span> {t("add_wbs")}
              </button>
            )}
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0" style={{ minWidth: "1100px" }}>
              <thead>
                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                  <th className="py-3 border-0">{t("wbs_element")}</th>
                  <th className="py-3 border-0">{t("wbs_element_name")}</th>
                  <th className="py-3 border-0">{t("project_code")}</th>
                  <th className="py-3 border-0">{t("project_name")}</th>
                  <th className="py-3 border-0 text-center">{t("status")}</th>
                  <th className="py-3 border-0 text-center">{t("actions")}</th>
                </tr>
              </thead>
              <tbody>
                {data_wbs.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center text-secondary py-5">
                      {t("no_data")}
                    </td>
                  </tr>
                ) : (
                  data_wbs.map((item, idx) => (
                    <tr key={idx} className="border-bottom border-light bg-white">
                      <td>
                        <div className="text-secondary text-14">{item.wbs_element}</div>
                      </td>
                      <td>
                        <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "250px" }} title={item.wbs_element_name}>
                          {item.wbs_element_name}
                        </div>
                      </td>
                      <td>
                        <div className="text-secondary text-14">{item.project?.project_code || "-"}</div>
                      </td>
                      <td>
                        <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "250px" }} title={item.project?.name}>
                          {item.project?.name || "-"}
                        </div>
                      </td>
                      <td className="text-center">{this.renderStatusBadge(item.is_active)}</td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-2 justify-content-center">
                          <ActionIconButton label={can("projects.update") ? t("edit") : t("view")} icon={can("projects.update") ? ACTION_ICONS.edit : ACTION_ICONS.view} variant={can("projects.update") ? "warning" : "primary"} onClick={() => this.openWbsEditModal(item)} />
                          {can("projects.delete") && (
                            <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.DeleteWbs(item.uid)} />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer Pagination */}
        <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
          <div>
            {t("showing")} 1-{data_wbs.length} {t("of")} {fmtInt(wbs_count)} {t("items")}
          </div>
          <Pagination
            className="mb-0"
            count={Math.ceil(wbs_count / PAGE_SIZE) || 1}
            page={wbs_page}
            showFirstButton={false}
            showLastButton={false}
            onChange={(_, p) => this.GetWbs(p)}
          />
        </div>
      </>
    );
  }

  render() {
    const {
      active_tab,
      modal_create,
      modal_update,
      project_code,
      name,
      owner_code,
      owner_name,
      planned_start_date,
      planned_finish_date,
      actual_start_date,
      actual_finish_date,
      processing_status,
      project_manager,
      description,
      sap_created_by,
      sap_created_on,
      is_active,
      modal_wbs_create,
      modal_wbs_update,
      data_project,
      wbs_project_id,
      wbs_element,
      wbs_element_name,
      entity_guid,
      wbs_is_active,
    } = this.state;

    const tabs = [
      { key: TAB_PROJECT, icon: "", label: t("projects") },
      { key: TAB_WBS, icon: "", label: t("wbs_list") },
    ];

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          {/* Header Section */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("project_management")}</h3>
              <div className="text-secondary text-14">{t("manage_projects_desc")}</div>
            </div>
          </div>

          {/* Tabs */}
          <div className="d-flex border-bottom gap-4 mb-4">
            {tabs.map((tab) => (
              <div
                key={tab.key}
                className={`pb-2 pointer fw-bold d-flex align-items-center ${active_tab === tab.key ? "text-primary" : "text-secondary"}`}
                style={{ borderBottom: active_tab === tab.key ? "3px #1976D2 solid" : "" }}
                onClick={() => this.switchTab(tab.key)}
              >
                <span className="icon me-2">{tab.icon}</span> {tab.label}
              </div>
            ))}
          </div>

          {active_tab === TAB_PROJECT ? this.renderProjectTab() : this.renderWbsTab()}
        </div>

        {/* MODAL: CREATE / EDIT PROJECT */}
        <Modal
          show={modal_create || modal_update}
          onHide={() => this.setState({ modal_create: false, modal_update: false })}
          centered
          size="lg"
          contentClassName="border-0 rounded-4 shadow-lg"
        >
          <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
            <h5 className="fw-bold mb-0 text-dark">
              {modal_update ? t("edit_project") : t("add_new_project")}
            </h5>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
<fieldset disabled={modal_update && !can("projects.update")} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
            <div className="row g-4">
              <div className="col-12">
                <small className="text-muted d-block mb-3">{t("basic_info_desc")}</small>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">
                      {t("project_code")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control py-2"
                      value={project_code}
                      onChange={(e) => this.setState({ project_code: e.target.value })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">
                      {t("project_name")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control py-2"
                      value={name}
                      onChange={(e) => this.setState({ name: e.target.value })}
                    />
                  </div>
                </div>
              </div>

              {/* ข้อมูลโครงการจาก SAP */}
              <div className="col-12 mt-4 border-top pt-4">
                <h6 className="fw-bold mb-1 d-flex align-items-center">
                  <span className="icon text-primary me-2">{"\uf15c"}</span> {t("project_sap_info")}
                </h6>
                <small className="text-muted d-block mb-3">{t("project_sap_info_desc")}</small>
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label text-14 text-dark mb-2">{t("owner_code")}</label>
                    <input
                      type="text"
                      className="form-control py-2"
                      value={owner_code}
                      onChange={(e) => this.setState({ owner_code: e.target.value })}
                    />
                  </div>
                  <div className="col-md-8">
                    <label className="form-label text-14 text-dark mb-2">{t("owner_name")}</label>
                    <input
                      type="text"
                      className="form-control py-2"
                      value={owner_name}
                      onChange={(e) => this.setState({ owner_name: e.target.value })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">{t("planned_start_date")}</label>
                    <DatePicker type="th" className="form-control" value={planned_start_date} onChange={(val) => this.setState({ planned_start_date: val || "" })} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">{t("planned_finish_date")}</label>
                    <DatePicker type="th" className="form-control" value={planned_finish_date} onChange={(val) => this.setState({ planned_finish_date: val || "" })} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">{t("actual_start_date")}</label>
                    <DatePicker type="th" className="form-control" value={actual_start_date} onChange={(val) => this.setState({ actual_start_date: val || "" })} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">{t("actual_finish_date")}</label>
                    <DatePicker type="th" className="form-control" value={actual_finish_date} onChange={(val) => this.setState({ actual_finish_date: val || "" })} />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">{t("processing_status")}</label>
                    <input
                      type="text"
                      className="form-control py-2"
                      value={processing_status}
                      onChange={(e) => this.setState({ processing_status: e.target.value })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">{t("project_manager")}</label>
                    <input
                      type="text"
                      className="form-control py-2"
                      value={project_manager}
                      onChange={(e) => this.setState({ project_manager: e.target.value })}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label text-14 text-dark mb-2">{t("description")}</label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={description}
                      onChange={(e) => this.setState({ description: e.target.value })}
                    />
                  </div>
                  {(sap_created_by || sap_created_on) && (
                    <div className="col-12 text-secondary text-12">
                      {t("sap_created_by")}: {sap_created_by || "-"} · {t("sap_created_on")}:{" "}
                      {sap_created_on ? `${new Date(sap_created_on).toISOString().slice(0, 19).replace("T", " ")} UTC` : "-"}
                    </div>
                  )}
                </div>
              </div>

              {this.renderStatusRadio("projectStatus", is_active, (status) => this.setState({ is_active: status }))}
            </div>
          </fieldset>
</Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
            <button
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
              onClick={() => this.setState({ modal_create: false, modal_update: false })}
            >
              {t("cancel")}
            </button>
            {!(modal_update && !can("projects.update")) && (
              <button
                className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                onClick={this.CreateUpdate}
              >
                <span className="icon me-2">{""}</span> {t("save")}
              </button>
            )}
          </Modal.Footer>
        </Modal>

        {/* MODAL: CREATE / EDIT WBS */}
        <Modal
          show={modal_wbs_create || modal_wbs_update}
          onHide={() => this.setState({ modal_wbs_create: false, modal_wbs_update: false })}
          centered
          size="lg"
          contentClassName="border-0 rounded-4 shadow-lg"
        >
          <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
            <h5 className="fw-bold mb-0 text-dark">{modal_wbs_update ? t("edit_wbs") : t("add_new_wbs")}</h5>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
<fieldset disabled={modal_wbs_update && !can("projects.update")} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
            <div className="row g-4">
              <div className="col-12">
                <small className="text-muted d-block mb-3">{t("basic_info_desc")}</small>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label text-14 text-dark mb-2">
                      {t("label_project")} <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="form-control"
                      options={data_project}
                      value={wbs_project_id}
                      placeholder={t("select_project")}
                      onChange={(value) => this.setState({ wbs_project_id: value || "" })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">
                      {t("wbs_element")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control py-2"
                      value={wbs_element}
                      onChange={(e) => this.setState({ wbs_element: e.target.value })}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-14 text-dark mb-2">{t("wbs_element_name")}</label>
                    <input
                      type="text"
                      className="form-control py-2"
                      value={wbs_element_name}
                      onChange={(e) => this.setState({ wbs_element_name: e.target.value })}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label text-14 text-dark mb-2">{t("entity_guid")}</label>
                    <input
                      type="text"
                      className="form-control py-2"
                      value={entity_guid}
                      onChange={(e) => this.setState({ entity_guid: e.target.value })}
                    />
                  </div>
                </div>
              </div>

              {this.renderStatusRadio("wbsStatus", wbs_is_active, (status) => this.setState({ wbs_is_active: status }))}
            </div>
          </fieldset>
</Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
            <button
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
              onClick={() => this.setState({ modal_wbs_create: false, modal_wbs_update: false })}
            >
              {t("cancel")}
            </button>
            {!(modal_wbs_update && !can("projects.update")) && (
              <button
                className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                onClick={this.CreateUpdateWbs}
              >
                <span className="icon me-2">{""}</span> {t("save")}
              </button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
